<template>
  <div>
    <el-card class="box-card" v-auth="'/user/pageList'">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="searchForm.username"
                placeholder="请输入用户名"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="昵称" prop="nickname">
              <el-input
                v-model="searchForm.nickname"
                placeholder="请输入昵称"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="名字" prop="name">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入名字"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="searchForm.mobile"
                placeholder="请输入手机号"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              :size="buttonSize"
              type="primary"
              @click="pageList"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              v-auth="'/user/pageListreset'"
              :size="buttonSize"
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row>
        <el-col :span="12">
          <el-button
            v-auth="'/user/addUser'"
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            >新增</el-button
          >
          <el-button
            v-auth="'/user/deleteUser'"
            :size="buttonSize"
            type="danger"
            @click="batchDeleteUser"
            icon="el-icon-minus"
            >批量删除</el-button
          >
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            v-auth="'/user/importData'"
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            >导入</el-button
          >
          <el-button
            v-auth="'/user/exportExcel'"
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="tableLoading"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="sex" label="性别"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                v-auth="'/user/updateUser'"
                @click="(selection = scope.row.id), (editFormVisible = true)"
                >编辑</span
              >
              <span @click="deleteUser(scope.row)" v-auth="'/user/deleteUser'">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="addForm.username"
            placeholder="请输入用户名"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="addForm.password"
            placeholder="请输入密码"
            auto-complete="off"
            maxlength="64"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model="addForm.nickname"
            placeholder="请输入昵称"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="名字" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入名字"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="addForm.sex" placeholder="请选择性别">
            <el-option
              v-for="item in sexs"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="addForm.mobile"
            placeholder="请输入手机号"
            auto-complete="off"
            maxlength="16"
          ></el-input>
        </el-form-item>

        <el-form-item label="部门" prop="departmentId">
          <el-cascader
            :options="departmentList"
            :props="defaultProps"
            filterable
            placeholder="试试搜索"
            style="width: 100%"
            v-model="addForm.departmentId"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-select v-model="addForm.roles" multiple placeholder="请选择角色">
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="editForm.username"
            placeholder="请输入用户名"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="editForm.password"
            placeholder="请输入密码"
            auto-complete="off"
            maxlength="64"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model="editForm.nickname"
            placeholder="请输入昵称"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="名字" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入名字"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="editForm.sex" placeholder="请选择性别">
            <el-option
              v-for="item in sexs"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="editForm.mobile"
            placeholder="请输入手机号"
            auto-complete="off"
            maxlength="16"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="departmentId">
          <el-cascader
            :options="departmentList"
            :props="defaultProps"
            filterable
            placeholder="试试搜索"
            style="width: 100%"
            v-model="editForm.departmentId"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
          <el-select v-model="editForm.roles" multiple placeholder="请选择角色">
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateUser">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize"  type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="sex" label="性别"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departmentList: [],
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc",
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        username: "",
        nickname: "",
        name: "",
        mobile: "",
      },
      addForm: {
        username: "",
        password: "",
        nickname: "",
        departmentId: "",
        name: "",
        sex: "",
        mobile: "",
      },
      addFormRules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "用户名长度在1到64个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "密码长度在1到64个字",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "昵称长度在1到64个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "名字长度在1到64个字",
          },
        ],
        sex: [
          {
            required: true,
            message: "请输入性别",
            trigger: "blur",
          },
          {
            min: 1,
            max: 2,
            message: "性别长度在1到2个字",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "手机号格式不正确",
          },
        ],
      },
      editForm: {
        username: "",
        password: "",
        nickname: "",
        name: "",
        sex: "",
        departmentId: "",
        mobile: "",
      },
      editFormRules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "用户名长度在1到64个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "密码长度在1到64个字",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "昵称长度在1到64个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
          {
            min: 1,
            max: 64,
            message: "名字长度在1到64个字",
          },
        ],
        sex: [
          {
            required: true,
            message: "请输入性别",
            trigger: "blur",
          },
          {
            min: 1,
            max: 2,
            message: "性别长度在1到2个字",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/user/upload`,
      fileList: [],
      loading: false,
      tableLoading: false,

      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      sexs: ["男", "女", "保密"],
      roles: [],
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getUser() {
      this.api.user
        .getUser({ id: this.selection })
        .then((result) => {
          this.editForm = result.data;
          this.editForm.roles.map((e, index) => (this.editForm.roles[index] = e.id));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.user
        .pageList(this.searchForm)
        .then((result) => {
          this.tableLoading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          this.tableLoading = false;
          console.log(error);
        });
    },
    addUser() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var length = this.addForm.departmentId.length - 1;
          this.addForm.departmentId = this.addForm.departmentId[length];
          this.addForm.roles.map((e, index) => (this.addForm.roles[index] = { id: e }));
          this.api.user
            .addUser(this.addForm)
            .then((result) => {
              if (result.success) {
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
                this.addFormVisible = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateUser() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.roles.map((e, index) => (this.editForm.roles[index] = { id: e }));
          var length = this.editForm.departmentId.length - 1;
          this.editForm.departmentId = this.editForm.departmentId[length];
          this.api.user
            .updateUser(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteUser(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.user
            .deleteUser([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteUser() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.user
            .deleteUser(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.user
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.user
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRoleList() {
      this.api.role
        .getRoleList()
        .then((result) => {
          this.roles = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    departmentTreeList() {
      this.api.department.getNewDepartmentTreeList().then((result) => {
        if (result.success) {
          this.departmentList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getUser();
      }
    },
  },
  mounted() {
    this.pageList();
    this.getRoleList();
    this.departmentTreeList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/index.vue